import './App.css';
import Main from './items/main';

function App() {
  return (
    <div className="App">
      <Main/>
    </div>
  );
}

export default App;
